<template>
  <div>
    <label class="d-inline-block mb-2 subtitle-2">{{ label }}</label>
    <v-text-field
      v-model="textValue"
      outlined
      dense
      background-color="white"
    />
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    textValue: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  }
}
</script>
